<script>
export default {
    mounted() {
        this.$watch(this.headerScrollbarSpacerConfig.rowsName, () => {
            this.$nextTick(() => {
                this.computeHeaderMargin();
            });
        });

        setTimeout(() => {
            this.computeHeaderMargin();
        }, 200);
    },
    methods: {
        computeHeaderMargin() {
            const tbody = this.$refs.tbody;
            const spacer = this.$refs[this.headerScrollbarSpacerConfig.refName];
            if (!spacer) {
                return;
            }

            const buffer = 5;

            const diff = Math.abs(tbody.scrollHeight - $(tbody).height());
            if (diff > buffer) {
                spacer.style.width = this.getScrollbarWidth() + 'px';
                spacer.style.display = 'table-cell';
            } else {
                spacer.style.display = 'none';
            }
        },
        getScrollbarWidth() {
            const scrollDiv = document.createElement('div');
            scrollDiv.className = '__scrollbar-measure';
            document.body.appendChild(scrollDiv);
            const scrollbarWidth =
                scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
            return scrollbarWidth;
        },
    },
};
</script>

<style lang="scss">
.__scrollbar-measure {
    width: 100px;
    height: 100px;
    overflow: scroll;
    position: absolute;
    top: -9999px;
}
</style>
